import { createBrowserRouter, Navigate } from "react-router";
import { AdminLayout } from "./routes/admin/AdminLayout.js";
import { LoginPage } from "./routes/admin/LoginPage.js";
import { DashboardPage } from "./routes/admin/DashboardPage.js";
import { StudiesPage } from "./routes/admin/StudiesPage.js";
import { StudyLayout } from "./routes/admin/StudyLayout.js";
import { StudyConfigPage } from "./routes/admin/StudyConfigPage.js";
import { StudyMediaPage } from "./routes/admin/StudyMediaPage.js";
import { StudyParticipantsPage } from "./routes/admin/StudyParticipantsPage.js";
import { StudyResultsPage } from "./routes/admin/StudyResultsPage.js";
import { StudyExportPage } from "./routes/admin/StudyExportPage.js";
import { SettingsPage } from "./routes/admin/SettingsPage.js";
import { ParticipantPage } from "./routes/participant/ParticipantPage.js";
import { NotFoundPage } from "./routes/NotFoundPage.js";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  // Ruta del participante: aislada, sin navegación ni elementos del panel.
  { path: "/participar/:studyCode", element: <ParticipantPage /> },
  {
    path: "/",
    element: <AdminLayout />,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: "dashboard", element: <DashboardPage /> },
      { path: "estudios", element: <StudiesPage /> },
      {
        path: "estudios/:id",
        element: <StudyLayout />,
        children: [
          { index: true, element: <Navigate to="configuracion" replace /> },
          { path: "configuracion", element: <StudyConfigPage /> },
          { path: "multimedia", element: <StudyMediaPage /> },
          // Ruta anterior (enlaces guardados).
          { path: "imagenes", element: <Navigate to="../multimedia" replace /> },
          { path: "participantes", element: <StudyParticipantsPage /> },
          { path: "resultados", element: <StudyResultsPage /> },
          { path: "exportar", element: <StudyExportPage /> },
        ],
      },
      { path: "ajustes", element: <SettingsPage /> },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
]);
